<button mat-raised-button id="tasks-filter" (click)="showFilter()">
  <mat-icon>filter</mat-icon> Filter
</button>
